import React, { FC, useState } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import ActivityApi from '@api/activity.api'
import i18n from 'i18next'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { Icon, UseHeader, CouponItem } from '@cps'
import { keyBy } from '@dt/fe-utils/dist/lodash'
import { virtualOrderMobx } from '@mobxStore'
import { useHistoryNew, getCouponsInfo } from '@utils'
import './index.scss'

interface IProps extends IPage, RouteComponentProps {
}

let clickType: boolean = false

const PaySuccess: FC<IProps> = ({ match }) => {
  const history = useHistoryNew()
  const { orderId } = match.params as any
  const { getVirtualOrder } = virtualOrderMobx
  const [coupons, setCoupons] = useState<any>([])
  const [couponDetails, setCouponDetails] = useState<any>({})
  const [status, setStatus] = useState<boolean>(true)
  const [showAll, setShowAll] = useState<boolean>(false)
  const getShowAll = () => {
    if (coupons.length > 3) {
      setShowAll(!showAll)
    }
  }
  const closePage = () => {
    history.goBack()
  }
  const checkInfo = () => {
    if (status) {
      history.push('/iCoupon')
    } else {
      getData()
    }
  }
  const transCoupons = (list: any) => {
    ActivityApi.getCouponsList({ couponIds: getCouponsInfo(list) }).then((coupon: any) => {
      if (coupon?.length > 0) {
        setCouponDetails(keyBy(coupon, 'couponId'))
      }
    })
  }
  const getData = () => {
    if (clickType) return
    clickType = true
    getVirtualOrder(orderId).then((res: any) => {
      clickType = false
      if (res && res?.orderDetail.length > 0) {
        setStatus(true)
        ActivityApi.getRedeemCoupons({ redeemProductId: parseInt(res.orderDetail[0].productNo) }).then((res: any) => {
          if (res) {
            transCoupons(res)
            setCoupons(res)
          }
        })
      } else {
        setStatus(false)
      }
    })
  }
  useIonViewWillEnter(() => {
    if (orderId) getData()
  })
  return (
    <IonPage
      className='pay-success-page'
      title={i18n.t('groupBuy.paySucc')}
    >
      <UseHeader title={i18n.t('common.back')} onBack={() => closePage()}></UseHeader>
      <IonContent className='page-content'>
        <div className='success-panel'>
          <div className='top-block'>
            <Icon className={status ? 'icon' : 'icon warn'} name={status ? 'checkmark--outline' : 'warning'} />
            <div className='title'>{status ? i18n.t('mkt.member.buySuccess') : i18n.t('mkt.groupBuy.abnormal')}</div>
            {
              !status && <div className='desc'>{i18n.t('mkt.groupBuy.abnormalTip2')}</div>
            }
          </div>
          {
            status &&
              <div className='middle-block'>
                <div className='desc'>{i18n.t('mkt.groupBuy.successTip')}</div>
                {
                  Object.keys(couponDetails).length > 0 && coupons.map((item: any, index: number) => {
                    const hasItem: any = couponDetails[item.couponId]
                    return hasItem && (
                      (showAll ? index < coupons.length : index < 3) &&
                        <div className='coupon-block' key={`${index}-${item.couponId}`}>
                          <CouponItem type='get' couponInfo={hasItem} cnt={item.couponCnt > 1 ? item.couponCnt : ''}></CouponItem>
                        </div>
                    )
                  })
                }
                {
                  coupons.length > 3 && <div className='coupons-num' onClick={getShowAll}>{showAll ? i18n.t('common.hide') : i18n.t('mkt.groupBuy.showAll')}</div>
                }
              </div>
          }
          <div className='bottom-block'>
            <div className='btn' onClick={checkInfo}>{status ? i18n.t('mkt.coupon.myCoupon') : i18n.t('mkt.groupBuy.refresh')}</div>
          </div>
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(PaySuccess)
